<script lang="ts">
    import { getColourClass } from "../styles/nameColourClasses";
    import { convertNameToColour } from "../misc/nameToColour";

    type NumberOfTilesMapping = {
        [index: string]: number;
    };

    export let players: string[] = [];
    export let currentPlayer: string = "";
    export let offlinePlayers: string[] = [];
    export let numberOfTiles: NumberOfTilesMapping = {};

    const colourClassOfName = (name: string) => {
        return getColourClass(convertNameToColour(name));
    };

    let offlineClassOfName: { [player: string]: string } = {};
    $: {
        for (const player of players) {
            offlineClassOfName[player] = offlinePlayers.includes(player)
                ? "offline"
                : "";
        }
    }

    const playerHasNumberOfTiles = (playerName: string) => {
        return (
            numberOfTiles[playerName] !== null &&
            numberOfTiles[playerName] !== undefined
        );
    };
</script>

<section id="player-list-panel">
    <div class="player-list-head">
        <h2>Players</h2>
        <span>Tiles</span>
    </div>
    <div id="player-list">
        {#each players as player, index (index)}
            <article
                class={`player-row ${player === currentPlayer ? "current" : ""} ${offlineClassOfName[player]}`}
            >
                <div class="player-main">
                    <span class={`presence ${offlinePlayers.includes(player) ? "offline-presence" : ""}`} />
                    <div class="player-copy">
                        <strong class={`${colourClassOfName(player)} ${offlineClassOfName[player]}`}>
                            {player}{#if player === currentPlayer} (You){/if}
                        </strong>
                        {#if player === currentPlayer}
                            <span class={`compat-label ${offlineClassOfName[player]}`}>* {player}</span>
                        {/if}
                        {#if playerHasNumberOfTiles(player)}
                            <span class={`compat-label ${offlineClassOfName[player]}`}>{player} ({numberOfTiles[player]})</span>
                        {/if}
                        <small>{offlinePlayers.includes(player) ? "Offline" : "Online"}</small>
                    </div>
                </div>
                {#if playerHasNumberOfTiles(player)}
                    <span class="tile-total">{numberOfTiles[player]}</span>
                {/if}
            </article>
        {/each}
    </div>
</section>

<style>
    #player-list-panel {
        border-radius: var(--radius-lg);
        border: 1px solid rgba(126, 173, 255, 0.16);
        background: rgba(9, 22, 40, 0.78);
        padding: 18px;
    }

    .player-list-head {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        margin-bottom: 14px;
    }

    .player-list-head h2,
    .player-list-head span {
        margin: 0;
    }

    .player-list-head span {
        color: var(--text-dim);
        font-size: 0.78rem;
        text-transform: uppercase;
        letter-spacing: 0.14em;
    }

    #player-list {
        max-height: 260px;
        overflow: auto;
        display: grid;
        gap: 10px;
    }

    .player-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        padding: 14px 16px;
        border-radius: var(--radius-md);
        border: 1px solid rgba(126, 173, 255, 0.12);
        background: rgba(17, 36, 64, 0.72);
    }

    .player-row.current {
        box-shadow: inset 0 0 0 1px rgba(255, 207, 99, 0.16);
        border-color: rgba(255, 207, 99, 0.3);
    }

    .player-main {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .presence {
        width: 12px;
        height: 12px;
        border-radius: 999px;
        background: rgba(115, 235, 124, 0.92);
        box-shadow: 0 0 0 6px rgba(115, 235, 124, 0.08);
    }

    .offline-presence {
        background: rgba(255, 118, 111, 0.85);
        box-shadow: 0 0 0 6px rgba(255, 118, 111, 0.08);
    }

    .player-copy {
        display: grid;
        gap: 4px;
        position: relative;
    }

    .player-copy strong {
        font-size: 1.05rem;
    }

    .player-copy small {
        color: var(--text-dim);
    }

    .tile-total {
        font-size: 1.7rem;
        font-weight: 700;
        color: var(--text-main);
    }

    .offline {
        opacity: 0.6;
    }

    .compat-label {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
    }
</style>
